<template>
  <div class="mb-4">
    <p class="text-sm font-semibold mb-2">{{ $t("category") }}</p>
    <select
      :value="modelValue ?? DEFAULT_CATEGORY_ID"
      class="w-full border border-surface-300 dark:border-surface-600 rounded-lg px-3 py-2 text-sm bg-surface-0 dark:bg-surface-800 focus:outline-none focus:border-primary"
      @change="emit('update:modelValue', ($event.target as HTMLSelectElement).value)"
    >
      <option v-for="category in categories" :key="category.id" :value="category.id">
        {{ category.label }}
      </option>
    </select>
  </div>
</template>

<script setup lang="ts">
const DEFAULT_CATEGORY_ID = "22";

defineProps<{
  modelValue?: string;
}>();

const emit = defineEmits<{
  "update:modelValue": [value: string];
}>();

const categories: { id: string; label: string }[] = [
  { id: "2", label: "Cars and vehicles" },
  { id: "23", label: "Comedy" },
  { id: "27", label: "Education" },
  { id: "24", label: "Entertainment" },
  { id: "1", label: "Film and animation" },
  { id: "20", label: "Gaming" },
  { id: "26", label: "How-to and style" },
  { id: "10", label: "Music" },
  { id: "25", label: "News and politics" },
  { id: "29", label: "Non-profits and activism" },
  { id: "22", label: "People and blogs" },
  { id: "15", label: "Pets and animals" },
  { id: "28", label: "Science and technology" },
  { id: "17", label: "Sport" },
  { id: "19", label: "Travel and events" },
];
</script>
